import { useRequestSetCoinsToUser, useRequestAddIncognitoToUser, useRequestAddBoostToUser } from '@/hooks/httpRequest';
import { Button, DialogFooter } from '@/components/ui';
import { useFormContext } from 'react-hook-form';
import { broadcastService } from '@/services';
import { TCallbackForm } from '@/types';
import { notify } from '@/functions';
import { MainTabEnum } from './mainTab.enum';
import { TFormData } from '.';

type TProps = {
  disableInvalidateQueries?: boolean;
  callback?: TCallbackForm<TFormData>;
};

const FormSetCoinsToUserFooter = ({ callback, disableInvalidateQueries }: TProps) => {

  const { triggerSetCoinsToUser, isLoadingSetCoinsToUser } = useRequestSetCoinsToUser({ disableInvalidateQueries });
  const { triggerAddIncognitoToUser, isLoadingAddIncognitoToUser } = useRequestAddIncognitoToUser({ disableInvalidateQueries });
  const { triggerAddBoostToUser, isLoadingAddBoostToUser } = useRequestAddBoostToUser({ disableInvalidateQueries });
  const { handleSubmit, formState: { isValid, isSubmitting } } = useFormContext<TFormData>();

  const isLoading = isLoadingSetCoinsToUser || isLoadingAddIncognitoToUser || isLoadingAddBoostToUser;

  const handleOnClickBtnCancel = () => {
    // Close modal
    broadcastService.modal.hide();
    // Callback
    callback?.({ event: 'canceled' });
  };

  const handleOnClickBtnSave = () =>
    handleSubmit(
      data => {
        let notificationMessage: string;
        let request: Promise<unknown>;

        if (data.mainTab === MainTabEnum.INCOGNITO) {
          notificationMessage = `Un pack incognito a été ajouté à ${data.user.username}`;
          request = triggerAddIncognitoToUser({
            userId: data.user.id,
            packageName: data.incognitoPackageName!,
            product: data.product!,
            comment: data.comment
          });
        } else if (data.mainTab === MainTabEnum.BOOST) {
          notificationMessage = `Un boost a été ajouté à ${data.user.username}`;
          request = triggerAddBoostToUser({
            userId: data.user.id,
            packageName: data.boostPackageName!,
            product: data.product!,
            comment: data.comment
          });
        } else {
          notificationMessage = `Un package de pièces a été ajouté à ${data.user.username}`;
          request = triggerSetCoinsToUser({
            userId: data.user.id,
            type: 'increment',
            packageName: data.coinPackageName!,
            product: data.product!,
            comment: data.comment
          });
        }

        // Close modal right away, don't wait for the request
        broadcastService.modal.hide();
        callback?.({ event: 'success', data });

        // Save in background
        request
          .then(() => notify(notificationMessage))
          .catch(
            error => {
              let errorMessage = error?.message ?? error?.internalMessage;

              if (error?.internalCode === 1031) {
                errorMessage = `Vous n'avez pas la permission pour effectuer cette opération!`;
              }

              notify(errorMessage, 'error');
            }
          );
      }
    )();

  return (
    <DialogFooter>
      <div className='w-full flex justify-between'>
        <Button
          onClick={handleOnClickBtnCancel}
          disabled={isSubmitting || isLoading}
          variant='secondary'
          type='button'
          size={'sm'}>
          Annuler
        </Button>
        <Button
          onClick={handleOnClickBtnSave}
          disabled={isSubmitting || !isValid || isLoading}
          type='button'
          size={'sm'}>
          Enregistrer
        </Button>
      </div>
    </DialogFooter>
  );

};

export default FormSetCoinsToUserFooter;
